// removed by extract-text-webpack-plugin
module.exports = {"vpPlanCardButton":"vpPlanCardButton___3TmiN","vpPlanCardButtonDisabled":"vpPlanCardButtonDisabled___2i8Si","vpPlanCardButtonEligible":"vpPlanCardButtonEligible___1M91U","vpPlanCardButtonEnterprise":"vpPlanCardButtonEnterprise___1MOWH","VpCancelButton":"VpCancelButton___w6G4Y","vpPlanCardLayout":"vpPlanCardLayout___11xxc"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/components/VpPlanCards/VpPlanCard.module.less
// module id = 2816
// module chunks = 30